import produce from 'immer'
import React, { useEffect, useState } from 'react'
import { Row, Col, Form } from 'react-bootstrap'
import { useSelector } from 'react-redux'
import {
  useHistory,
  useRouteMatch,
  useLocation,
  Switch,
  Route,
} from 'react-router-dom'
import ActionButtonComponent from '../../../components/common/actionButton/ActionButtonComponent'
import LoadingComponent from '../../../components/common/loading/LoadingComponent'

import IterminalTableComponent from '../../../components/table/IterminalTableComponent'
import { ActionListModal } from '../../../models/package/actionListModal'
import { FilterModel } from '../../../models/utils/filterModel'
import { FilterOptionModel } from '../../../models/utils/filterOption'

import { getUserSubPackageActions } from '../../../store/user/selectors'
import {
  defaultPageLimit,
  //   defaultOrderListLimit,
} from '../../../utils/constants'
import { getPageCount } from '../../../utils/tableFunctions'
import PoliceStationServices from '../../../services/systemConfiguration/manegePoliceStation/policeStationServices'
import AddPoliceStations from './AddPoliceStations'
import ViewPoliceStations from './ViewPoliceStations'
import ModifyPoliceStations from './ModifyPoliceStations'

const ManagePoliceStation = () => {
  const [state, setState] = useState([])
  const pending = false
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const history = useHistory()
  const { path } = useRouteMatch()
  const location = useLocation()
  const [loading, setLoading] = useState(true)
  const filterOption: FilterModel = {
    descending: true,
    limit: defaultPageLimit,
    page: 1,
    orderFields: [],
    filterData: [] as FilterOptionModel[],
  }
  const [filter, setFilter] = useState(filterOption)
  const [pageCount, setPageCount] = useState(0)
  const [dataCount, setDatacount] = useState(0)

  const actionList = useSelector(
    getUserSubPackageActions('system-configuration', 'police-station')
  )

  const checkPermission = (permissionName: string) => {
    const filterdAction = actionList.filter((action: ActionListModal) => {
      if (action.action.name === permissionName) {
        return action
      }
    })[0]
    if (filterdAction != null) {
      return true
    } else {
      return false
    }
  }
  useEffect(() => {
    // dispatch(filtersSetRequest({ filters: propertyDamageTypeFilters }))
    async function getIncidentTypesData() {
      await retriveDataCountAndData(filter)
      setLoading(false)
    }
    getIncidentTypesData()
  }, [location.pathname])
  async function retriveDataCountAndData(filterData: FilterModel) {
    const propertyCountData =
      await PoliceStationServices.apiFetchPoliceStationListCount(filterData)
    setDatacount(propertyCountData.data.count)
    setPageCount(getPageCount(propertyCountData.data.count, filterOption.limit))
    const propertyData = await PoliceStationServices.apiFetchPoliceStationList(
      filterData
    )
    setState(propertyData.data)
  }

  // const retriveFilterData = async (selectedFilters: FilterOptionModel[]) => {
  //   console.log(selectedFilters)
  //   setLoading(true)
  //   const newFilter = produce(filter, (draft) => {
  //     draft.page = 1
  //     draft.filterData = selectedFilters
  //   })
  //   setFilter(newFilter)
  //   await retriveDataCountAndData(newFilter)
  //   setLoading(false)
  // }

  const retriveData = async (pageDetails: any) => {
    setLoading(true)
    const newFilter = produce(filter, (draft) => {
      draft.page = pageDetails.pageIndex + 1
    })
    setFilter(newFilter)

    const propertyData = await PoliceStationServices.apiFetchPoliceStationList(
      newFilter
    )
    setState(propertyData.data)
    setLoading(false)
  }
  const columns = React.useMemo(
    () => [
      {
        Header: 'Name',
        accessor: 'name',
      },
      {
        Header: 'Status',
        accessor: 'status',
      },
    ],
    []
  )
  const handleView = (id: number) => {
    history.push(`${path}/view/${id}`)
  }

  const handleSearch = async (searchTerm: string) => {
    const trimmed = searchTerm.trim()
    const newFilter = produce(filter, (draft) => {
      draft.filterData = trimmed
        ? [
            {
              property: 'name',
              value: trimmed,
              operator: 'LIKE',
              selected: true,
              label: 'Name',
              dropdownValue: null,
            },
          ]
        : []
      draft.page = 1
    })
    setFilter(newFilter)
    await retriveDataCountAndData(newFilter)
  }

  return (
    <>
      <Row className="title-layout">
        <Col className="d-flex justify-content-start">
          {/* <img src={rejection_return_reason} alt="" /> */}
          <span className="m-2">Manage Police Stations</span>
        </Col>
      </Row>
      {pending ? (
        <div className="loading-layout">
          <LoadingComponent />
        </div>
      ) : (
        <Switch>
          <Route path={`${path}/`} exact>
            <Row className="incident-types-body-layout mt-4">
              <Col sm={12} className="mb-4">
                <Row className="align-items-center">
                  <Col sm={8}>
                    <Form.Group controlId="policeStationSearchInput">
                      <Form.Label>Search by Police Station Name</Form.Label>
                      <Form.Control
                        type="text"
                        className="me-3"
                        placeholder="Search by Police Station Name"
                        onChange={(e) => handleSearch(e.target.value)}
                      />
                    </Form.Group>
                  </Col>
                  <Col sm={4} className="d-flex justify-content-end">
                    {checkPermission('add') === true && (
                      <ActionButtonComponent name="Add" routeURL="add" />
                    )}
                  </Col>
                </Row>
              </Col>
              <Col sm={12}>
                <IterminalTableComponent
                  columns={columns}
                  data={state}
                  fetchData={retriveData}
                  loading={loading}
                  pageCount={pageCount}
                  totalCount={dataCount}
                  onClickRow={(row: any) => {
                    console.log(row)
                    handleView(row.id)
                  }}
                />
              </Col>
            </Row>
          </Route>
          <Route path={`${path}/add`} component={AddPoliceStations} />
          <Route path={`${path}/view/:id`} component={ViewPoliceStations} />
          <Route path={`${path}/modify/:id`} component={ModifyPoliceStations} />
        </Switch>
      )}
    </>
  )
}

export default ManagePoliceStation
